import type { FunctionComponent } from "react";
import MetricsAdminPartial from "../../../partials/admin/global-metrics/metrics.admin.partials";

export const MetricsAdminScreen: FunctionComponent = () => {
	return <MetricsAdminPartial />;
};
